import type { FunctionComponent } from 'react';

import { formatRelative } from '@trello/dates/i18n';

import type { DateEntity } from './types';

type DateProps = Pick<DateEntity, 'date'>;

// TODO: Date refreshing ?

export const Date: FunctionComponent<DateProps> = ({ date }) => {
  if (!date) {
    return null;
  }

  return <>{formatRelative(new window.Date(date), new window.Date())}</>;
};
